import type { SyntheticEvent } from 'react';

export interface IsClickEventToOpenNewTabOptions {
	shouldCheckIframe?: boolean;
}

/**
 * Duplicated from @confluence/linking-platform to avoid circular dependency.
 * Original: next/packages/linking-platform/src/utils/isClickEventToOpenNewTab.ts
 */
export const isClickEventToOpenNewTab = (
	e: SyntheticEvent,
	{ shouldCheckIframe = false }: IsClickEventToOpenNewTabOptions = {},
): boolean => {
	const { metaKey, ctrlKey, shiftKey } = e.nativeEvent as MouseEvent;
	const hasModifierKeyPressed = metaKey || ctrlKey || shiftKey;

	const isInIframe = shouldCheckIframe ? window.top !== window : false;

	return hasModifierKeyPressed || isInIframe;
};
